import { Button } from "@/components/primitives/button";
import { StepProps } from "@/components/shared/Wizard/Wizard";
import { RECOVERY_DELAY_KEYS } from "@/config/constants";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { useTranslation } from "react-i18next";
import lock from "../../../assets/img/lock.svg";

export default function StartStep({ onNext, onClose }: StepProps) {
  const { t } = useTranslation();
  const [, setRecoveryKeyRemind] = useLocalStorage<number>(
    RECOVERY_DELAY_KEYS.STORAGE_KEY,
    Date.now(),
  );
  function handleDelay() {
    setRecoveryKeyRemind(Date.now() + RECOVERY_DELAY_KEYS.DELAY_PERIOD);
    onClose?.();
  }
  return (
    <div className="flex size-full select-none flex-col items-center justify-center gap-4">
      <img src={lock} className="mb-4 size-16" alt="Lock Icon" />
      <h2 className="mb-4 text-lg font-semibold">{t("recover.startTitle")}</h2>
      <p className="text-center font-light opacity-50">
        {t("recover.startDescription")}
      </p>
      <div className="mt-12 flex w-full flex-col items-stretch gap-4">
        <Button onClick={() => onNext()} className="mx-4">
          {t("next")}
        </Button>
        <span
          className="cursor-pointer self-center text-secondary"
          onClick={handleDelay}
        >
          {t("recover.delay2Weeks")}
        </span>
      </div>
    </div>
  );
}
